import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "speaker-guidelines"
    }}>{`Speaker guidelines`}</h1>
    <h2 {...{
      "id": "about-us"
    }}>{`About us`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.meetup.com/NYC-Design-Systems-Coalition/"
      }}>{`Design Systems Coalition`}</a>{` is a niche meetup for people enthusiastic about design systems. This includes professionals, freelancers, designers and developers, brand designers, managers and directors, product managers, and anyone else interested in learning more or sharing their own experiences with building design systems.`}</p>
    <p>{`The NYC meetup is organized by `}<a parentName="p" {...{
        "href": "https://twitter.com/broccolini"
      }}>{`Diana Mounter`}</a>{`, Design Systems Manager at `}<a parentName="p" {...{
        "href": "https://github.com/"
      }}>{`GitHub`}</a>{`, `}<a parentName="p" {...{
        "href": "https://twitter.com/tomtaki"
      }}>{`Tom Takigayama`}</a>{`, Design Lead at `}<a parentName="p" {...{
        "href": "%5Bhttps://justworks.com%5D(https://justworks.com/)"
      }}>{`Justworks`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://twitter.com/jxnblk"
      }}>{`Brent Jackson`}</a>{`, Principle UX developer at `}<a parentName="p" {...{
        "href": "https://www.priceline.com/"
      }}>{`Priceline.com`}</a>{`. The meetup first formed in San Francisco and has chapters popping up in cities around the globe. It was born out of the `}<a parentName="p" {...{
        "href": "http://designsystems.herokuapp.com/"
      }}>{`Design Systems slack`}</a>{` community started by `}<a parentName="p" {...{
        "href": "https://twitter.com/jina"
      }}>{`Jina Anne`}</a>{`. Jina is a design systems advocate, former design lead on the `}<a parentName="p" {...{
        "href": "https://www.lightningdesignsystem.com/"
      }}>{`Lightning Design System`}</a>{`, and organizer of `}<a parentName="p" {...{
        "href": "http://clarityconf.com/"
      }}>{`Clarity`}</a>{`.`}</p>
    <h2 {...{
      "id": "event-format"
    }}>{`Event format`}</h2>
    <p>{`Each meetup features 3 speakers giving 10 minute lightning talks on the same topic area. After the talks have finished we kick off a panel-style Q&A session with curated questions, and then open questions to the floor. Our goal with the lightning talks and Q&A is to stimulate discussion, keeping plenty of time for networking and meeting other design systems enthusiasts. We focus each meetup on one topic area so that it's easier for speakers to create a short and focussed talk, and to ensure that over time, we cover the many areas that design systems work involves.`}</p>
    <h2 {...{
      "id": "speakers"
    }}>{`Speakers`}</h2>
    <p>{`We strive to make this event comfortable for all backgrounds and levels of speaking experience. If you're new to speaking, we'll help you prepare for your talk via in-person feedback, video calls, or written feedback. Diana is an experienced speaker, and has stage managed and run her own conference. She can help you focus your talk based on community interest, and what works well for the lightning talk format.`}</p>
    <p>{`Talks that include a mix of high level ideas and process as well as some practical details, that are drawn from first hand experiences told with as much candidness as possible, are received well. This meetup is about sharing lessons and experiences so that we may all lift each other up. The audience will appreciate the "real talk" about how you started or grew your design system, not just the polished end result. Even if you're in the earlier stages of building design systems you can have very relevant experiences to share. Design systems aren't new, but what design systems mean in the tech industry is new to many, and there's a lot to learn and explore in this field. You don't have to be someone that works on design systems full-time to be a speaker, many aspects of design and development interconnect with design systems. The chances are, that even if you don't feel like an expert, you have an experience worth sharing.`}</p>
    <h2 {...{
      "id": "audience"
    }}>{`Audience`}</h2>
    <p>{`Meetup attendees tend to be a mix of designers and front-end developers. There's often folks with all different types of design systems experience, from different industries, big and small teams, and there's often people from agencies, freelancers, as well as people building systems within companies.`}</p>
    <h2 {...{
      "id": "presentation-details-and-av"
    }}>{`Presentation details and A/V`}</h2>
    <p>{`Each event is hosted at a different venue so the setup tends to vary. Most of the time you can use your own laptop and present in whatever format works for you. If you're new to speaking we recommend sharing your slides before the event for feedback.`}</p>
    <p>{`Most events are recorded which we'll confirm this with you before hand, but we recommend only presenting content that you're comfortable with being shared. Even if not recorded, we take photos and audience members take photos. If you're not comfortable with this please let us know before the event.`}</p>
    <h2 {...{
      "id": "timing"
    }}>{`Timing`}</h2>
    <p>{`The event usually starts at 6.30pm. We ask that speakers aim to arrive at 6pm to setup and check A/V. You'll be send a calendar invite with the time and location before the event to make it easier for you to keep track.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      